// @flow

import React from 'react'

type PropTypes = {
  src: string,
  onClick: Function,
}

export default (props: PropTypes) => (
  <div className="space-head__img">
    <a href="#" onClick={props.onClick}>
      <img src={props.src} alt="" itemProp="image" />
    </a>
    <a
      href="#"
      className="button-whiteblue space-head__showimage sm-hide"
      onClick={props.onClick}
    >
      {i18n.t('page.room.viewPhotos')}
    </a>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/CoverPhoto/index.jsx